// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeIntakeApi = class EdgeIntakeApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param HcpIntakeRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async intakeHcpIntake(HcpIntakeRequestModel, x_program_id) {
        const _url_ = '/edge/intake/HcpIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'HcpIntakeRequestModel' is not null or undefined
        if (HcpIntakeRequestModel === null || HcpIntakeRequestModel === undefined) {
            throw new Error('Required parameter HcpIntakeRequestModel was null or undefined when calling intakeHcpIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(HcpIntakeRequestModel, "HcpIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeHcpIntakeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IsHcpIntakeAllowedRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async intakeIsHcpIntakeAllowed(IsHcpIntakeAllowedRequestModel, x_program_id) {
        const _url_ = '/edge/intake/IsHcpIntakeAllowed';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IsHcpIntakeAllowedRequestModel' is not null or undefined
        if (IsHcpIntakeAllowedRequestModel === null || IsHcpIntakeAllowedRequestModel === undefined) {
            throw new Error('Required parameter IsHcpIntakeAllowedRequestModel was null or undefined when calling intakeIsHcpIntakeAllowed.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IsHcpIntakeAllowedRequestModel, "IsHcpIntakeAllowedRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeIsHcpIntakeAllowedDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PatientIntakeRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async intakePatientIntake(PatientIntakeRequestModel, x_program_id) {
        const _url_ = '/edge/intake/PatientIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PatientIntakeRequestModel' is not null or undefined
        if (PatientIntakeRequestModel === null || PatientIntakeRequestModel === undefined) {
            throw new Error('Required parameter PatientIntakeRequestModel was null or undefined when calling intakePatientIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PatientIntakeRequestModel, "PatientIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakePatientIntakeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param SimpleIntakeRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async intakeSimpleIntake(SimpleIntakeRequestModel, x_program_id) {
        const _url_ = '/edge/intake/SimpleIntake';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'SimpleIntakeRequestModel' is not null or undefined
        if (SimpleIntakeRequestModel === null || SimpleIntakeRequestModel === undefined) {
            throw new Error('Required parameter SimpleIntakeRequestModel was null or undefined when calling intakeSimpleIntake.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(SimpleIntakeRequestModel, "SimpleIntakeRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "IntakeSimpleIntakeDefaultResponse");
        }
        return response;
    }
};
EdgeIntakeApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeIntakeApi);
export { EdgeIntakeApi };
//# sourceMappingURL=edgeIntakeApi.js.map